"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _UIBreadcrumbs = _interopRequireDefault(require("UIComponents/nav/UIBreadcrumbs"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _propTypes2 = require("FileManagerCore/constants/propTypes");

var _FoldersAndFiles = require("FileManagerCore/utils/FoldersAndFiles");

var FolderBreadcrumbs = function FolderBreadcrumbs(_ref) {
  var folderWithAncestors = _ref.folderWithAncestors,
      onSelectFolder = _ref.onSelectFolder;

  if (!folderWithAncestors && folderWithAncestors.isEmpty()) {
    return null;
  }

  var ancestorPathItems = folderWithAncestors.toArray().map(function (folder) {
    return {
      name: folder.get('name'),
      folderId: folder.get('id')
    };
  });
  var currentFolder = ancestorPathItems.pop();

  var renderFolder = function renderFolder(_ref2, i) {
    var name = _ref2.name,
        folderId = _ref2.folderId;

    var handleClick = function handleClick() {
      var folder = folderId ? folderWithAncestors.find(function (f) {
        return f.get('id') === folderId;
      }) : (0, _FoldersAndFiles.getHomeFolder)();
      onSelectFolder(folder);
    };

    return _react.default.createElement(_UILink.default, {
      key: i,
      onClick: handleClick
    }, name);
  };

  return _react.default.createElement("div", null, _react.default.createElement(_UIBreadcrumbs.default, {
    className: "m-top-0 m-bottom-2",
    flush: true,
    singleBreadcrumbIsBackLink: false,
    wrapLevels: true
  }, ancestorPathItems.map(renderFolder)), currentFolder && _react.default.createElement("h5", {
    "data-test-id": "file-picker-folder-name"
  }, currentFolder.name));
};

FolderBreadcrumbs.propTypes = {
  folderWithAncestors: _propTypes2.listProp.isRequired,
  onSelectFolder: _propTypes.default.func.isRequired
};
var _default = FolderBreadcrumbs;
exports.default = _default;
module.exports = exports.default;